<template>
  <div class="sc-typing-indicator"
      :class="{
        sent: message.author === 'me',
        received: message.author !== 'me' && message.type !== 'system',
        system: message.type === 'system'
      }"> 
    <!-- :style="messageColors" -->
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    // messageColors: {
    //   type: Object,
    //   required: true
    // }
  }
}
</script>
<style scoped>

@import "./styles/typingMessage.css";

</style>



// WEBPACK FOOTER //
// src/components/beautiful-chat/TypingMessage.vue